import { Card, CardBody, CardHeader, Col, Row } from "reactstrap";
import CommercialTable from "./commercialTable";

const QuoteCommercials = ({ quoteModules, quoteItems, addQuoteItem, deleteQuoteItem, updateQuoteItem, updateQuoteItems }) => {

    return (
        <>
            <Card style={{ maxWidth: "100%", overflow: "hidden" }}>
                <CommercialTable
                    quoteItems={quoteItems}
                    updateQuoteItem={updateQuoteItem}
                    quoteModules={quoteModules}
                    updateQuoteItems={updateQuoteItems}
                />
            </Card>
        </>
    );
}

export default QuoteCommercials;